export const INSTRUCTIONS = [
    "1. Escanea el código QR del aforo.",
    "2. Cumple con los protocolos de bioseguridad.",
    "3. No te olvides de registrar tu salida." 
];